import { useQuery } from "react-query";
import axios from "axios";
import { USE_QUERY_OPTIONS } from "./useFetchGraphData";

export default function useFetch(endpoint) {
  return useQuery(
    [endpoint],
    async () => {
      const { data } = await axios.get(
        `${process.env.REACT_APP_ENDPOINT}/api/${endpoint}`
      );
      return data;
    },
    USE_QUERY_OPTIONS
  );
}
